import React from 'react';
import { number, func, string } from 'prop-types';

const ELLIPSIS = '…';

function PaginationButton({
  isActive,
  label,
  disabled,
  hidden,
  onClick,
  ...rest
}) {
  return (
    <li className="pagination__list-item">
      <button
        className="pagination__button"
        disabled={disabled}
        hidden={hidden}
        onClick={() => onClick(label)}
        {...rest}
      >
        {label}
      </button>
    </li>
  );
}

function calcPaginationArray(currentPage, totalPages) {
  return [...new Array(totalPages)]
    .map((_, index) => index + 1)
    .filter((number) => {
      if (
        number === 1 ||
        number === currentPage - 2 ||
        number === currentPage - 1 ||
        number === currentPage ||
        number === currentPage + 1 ||
        number === currentPage + 2 ||
        number === totalPages
      ) {
        return true;
      }

      return false;
    })
    .flatMap((number, index, array) => {
      if (index > 0 && number - 1 !== array[index - 1]) {
        return [ELLIPSIS, number];
      }

      return number;
    });
}

function Pagination({
  onPageChange,
  currentPage,
  totalPages,
  goToPageLabel,
  label
}) {
  return (
    totalPages > 1 && (
      <nav className="pagination" aria-label={label}>
        <ul className="pagination__list">
          {currentPage !== 1 && (
            <PaginationButton
              aria-label={`${goToPageLabel} ${currentPage - 1}`}
              label={
                <svg>
                  <use xlinkHref="#chevron-left-outline" />
                </svg>
              }
              onClick={() => onPageChange(currentPage - 1)}
            />
          )}
          {calcPaginationArray(currentPage, totalPages).map((number) => (
            <PaginationButton
              key={number}
              disabled={number === ELLIPSIS}
              onClick={onPageChange}
              label={number}
              {...(currentPage === number && { 'aria-current': true })}
              {...(number !== ELLIPSIS && {
                'aria-label': `${goToPageLabel} ${number}`
              })}
            />
          ))}
          {currentPage !== totalPages && (
            <PaginationButton
              aria-label={`${goToPageLabel} ${currentPage + 1}`}
              label={
                <svg>
                  <use xlinkHref="#chevron-right-outline" />
                </svg>
              }
              onClick={() => onPageChange(currentPage + 1)}
            />
          )}
        </ul>
      </nav>
    )
  );
}

Pagination.propTypes = {
  onPageChange: func.isRequired,
  currentPage: number.isRequired,
  totalPages: number.isRequired,
  goToPageLabel: string.isRequired
};

export default Pagination;
